import React from 'react';
import type { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { useAppDispatch } from '../../../store/store';
import { renderAccountDetails } from '../../../store/accountListSlice';
import { detectDeviceType, handleTabAction } from '../../../utils/helpers';
import { captureAnalyticsDataAttributes } from '../../../utils/analytics/analyticsDispatchers';
import '../../singleUseCard/singleUseCard.css';

interface BackToCardSummaryLinkProps {
  accountId: string;
  displayName: string;
  backToCardSummaryText: string | undefined;
  isAccordionCollapsed: boolean;
}

const BackToCardSummaryLink: FunctionComponent<BackToCardSummaryLinkProps> = ({
  accountId,
  displayName,
  backToCardSummaryText,
  isAccordionCollapsed,
}) => {
  const dispatch = useAppDispatch();
  const handleBackToCardSummaryClick = (event: any) => {
    // update redux flag here to show account details again
    dispatch(
      renderAccountDetails({
        accountId,
        renderAccountDetailsDisplayFlag: true, // showAccountDetails flag is flipped to true
      }),
    );
    captureAnalyticsDataAttributes(event);
  };

  return (
    <div className="single-use-card-link-section">
      <div className="single-use-card-link-content">
        <div className="back-to-card-wrapper">
          <div
            className="back-to-summary-img-wrapper"
            data-testid="test-for-handle-back-to-card-summary-click"
            data-reason={`backToCardSummary:${displayName}`}
            data-object="button"
            data-type={detectDeviceType}
            onClick={handleBackToCardSummaryClick}
            aria-label="back to card summary link"
            tabIndex={isAccordionCollapsed ? -1 : 0}
            onKeyDown={(e) => handleTabAction(e, handleBackToCardSummaryClick)}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="arrow-left" />
            <span className="link-option-text-block">
              {backToCardSummaryText}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackToCardSummaryLink;
